// Module
var code = `<div class="filter">
    <div data-bind="text: facet.label" class="filter-heading"></div>
    <div class="filter-panel">
        <input data-bind="attr: { name: 'filters[' + \$index() + '].Name', value: facet.name }" type="hidden"/>
        <form data-bind="visible: showFacetSearch" class="filter-search">
            <input data-bind="textInput: facetSearchQuery, attr: {placeholder: 'Zoeken naar ' + _.toLower(facet.label)}" class="filter-search-input" type="search" name="searchterm" placeholder="Zoeken" autocomplete="off" autocapitalize="off">
            <button data-bind="click: resetFacetSearchQuery" type="reset" class="clear-icon"></button>
        </form>
        <ul data-bind="css: {'open': facet.showValues()}" class="facets-list">
            <!-- ko foreach: matchingFacetValues().slice(0, facetLimit()) -->
            <li class="facet-item">
                <input data-bind="
                    attr: {
                        id: \$parent.facet.name + '_' + \$data.name(),
                        name: 'filters['+\$parentContext.\$index()+'].Values',
                        value: \$data.name()
                    },
                    checked: \$data.checked,
                    event: {change: \$root.handleSubmit}"
                       type="checkbox">
                <label data-bind="text: label, attr: { for: \$parent.facet.name + '_' + \$data.name() }"></label>
                <!-- ko if: \$parent.facet.name != 'stock' -->
                <span data-bind="text: \`(\${count()})\`" class="filter-count">0</span>
                <!-- /ko -->
            </li>
            <!-- /ko -->
            <!-- ko if: matchingFacetValueCount() > 5 -->
            <!-- ko ifnot: facet.showValues -->
            <li data-bind="click: facet.toggleValue" class="facet-toggle facet-toggle-open">
                <a data-bind="text: \`toon meer (\${matchingFacetValueCount()-5})\`" href="#!toggle">toon meer</a>
            </li>
            <!-- /ko -->
            <!-- ko if: facet.showValues() -->
            <li class="facet-toggle facet-toggle-closed">
                <a data-bind="click: facet.toggleValue" href="#!toggle">toon minder</a>
            </li>
            <!-- /ko -->
            <!-- /ko -->
            <li data-bind="visible: _.isEmpty(matchingFacetValues()) && !_.isEmpty(facetSearchQuery())">
                Geen opties gevonden voor "<span data-bind="text: facetSearchQuery">.</span>"
            </li>
        </ul>
        
    </div>
</div>
`;
// Exports
module.exports = code;